import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import Icon from 'material-ui/Icon'
import Snackbar from 'material-ui/Snackbar'
import Button from 'material-ui/Button'
import Table, {
	TableBody,
	TableCell,
	TableHead,
	TableRow
} from 'material-ui/Table'
import List, {
	ListItem,
	ListItemText
} from 'material-ui/List'
import Dialog, {
	DialogTitle,
	DialogContent,
	DialogActions,
} from 'material-ui/Dialog'
import { InputLabel } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import { CircularProgress } from 'material-ui/Progress'
import { get, post } from '../../services/apiServices'
import { token } from '../../services/authServices'
import ReactPaginate from 'react-paginate'
import TextField from 'material-ui/TextField'
import { FormControlLabel } from 'material-ui/Form'
import Checkbox from 'material-ui/Checkbox'

const styles = {
	closeIcon: {
		position: 'absolute',
		top: '10px',
		right: '10px',
		color: '#a9a9a9',
		cursor: 'pointer'
	},
	editIcon: {
		padding: '10px',
		cursor: 'pointer'
	},
	button: {
		width: '120px',
		margin: '0 auto 40px'
	},
	titleWrap: {
		marginTop: '15px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	title: {
		color: '#3f51b5'
	},
	table: {
		minWidth: 700,
	},
	tableRow: {
		cursor: 'pointer'
	},
	listItem: {
		width: "480px",
		alignItems: "flex-start",
		borderBottom: "1px solid rgba(224, 224, 224, 1)"
	},
	listItemText: {
		flex: "1 1 50%"
	},
	listItemTtitle: {
		fontWeight: 600
	},
	progressWrapper: {
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
	},
	progress: {
	}
};

class Accounts extends Component {
	constructor(props) {
		super(props);

		this.state = {
			'accounts': this.props.stages,
			'accountInfo': {},
			'openInfo': false,
			'open': false,
			'id': '',
			'deleteId': null,
			'name': '',
			'status': 0,
			'type': 'family',
			'maths_circle_id': null,
			'openSnackbar': false,
			'openConfirm': false,
			'message': ''
		}
	}

	getAccounts = () => {
		this.props.initAccounts().then(res => {
			this.setState({ 'accounts': this.props.accounts })
		})
	}

	handleOpenInfoModal = () => {
		this.setState({ 'openInfo': true })
	}

	handleCloseInfoModal = () => {
		this.setState({
			'openInfo': false
		})
	}


	handleCloseSnackbar = () => {
		this.setState({
			'openSnackbar': false,
			'message': ''
		})
	}

	handleOpenModal = () => {
		this.setState({ 'open': true })
	}

	handleOpenModalConfirm = (id, e) => {
		e.stopPropagation()

		this.setState({
			'openConfirm': true,
			'deleteId': id
		})
	}

	handleCloseModalConfirm = () => {
		this.setState({
			'openConfirm': false,
			'deleteId': null
		})
	}

	handleCloseModal = () => {
		this.setState({
			'open': false,
			'id': '',
			'name': '',
			'status': 0,
			'type': '',
			'maths_circle_id': null
		})
	}


	handleInputChange = e => {
		let newState = this.state;
		newState[e.target.name] = e.target.value;
		this.setState(newState)
	}

	handlePageChange = (action) => {
		this.props.pageChange(action.selected + 1).then(res => {
			this.setState({ 'accounts': this.props.accounts })
		})
	}

	getAccountInfo = (id, e) => {
		e.stopPropagation()

		get(`/admin/accounts/${id}`, token).then(res => {
			let accountInfo = res.data

			this.setState({
				'accountInfo': accountInfo.data,
				'openInfo': true
			})
		})
	}

	getSingleAccountData = (id, e) => {
		e.stopPropagation()

		let accounts = this.props.accounts.data
		let account = accounts.filter(item => item.id === id)
		let status = 0
		switch (account[0].status) {
			case 'awaiting confirm':
				status = 1
				break
			case 'active':
				status = 2
				break
		}
		this.setState({
			'id': account[0].id,
			'name': account[0].name,
			'type': account[0].type,
			'status': status,
			'maths_circle_id': account[0].maths_circle_id
		})

		this.handleOpenModal()
	}

	onSubmit = () => {
		let id = this.state.id ? `/${this.state.id}` : ''

		post(`/admin/accounts/${id}`, {
			'name': this.state.name,
			'status': this.state.status,
			'type': this.state.type,
			'maths_circle_id': this.state.maths_circle_id
		}, token).then(res => {
			this.handleCloseModal();
			this.getAccounts()
		})
	}

	renderAccountsList = () => {
		let items = this.state.accounts ?
			this.state.accounts.data : []
		let result = []

		items.map(item => {
			result.push(
				<TableRow
					className={this.classes.tableRow}
					key={item.id}
					onClick={() => this.props.toUsers(item.id)}>
					<TableCell padding='none'>
						{item.name}
					</TableCell>
					<TableCell padding='none'>
						{item.type}
					</TableCell>
					<TableCell padding='none'>
						{item.subscription_end}
					</TableCell>
					<TableCell padding='none'>
						{item.status}
					</TableCell>
					<TableCell width="100px" padding='none'>
						<Icon
							className={this.classes.editIcon}
							onClick={(e) => this.getAccountInfo(item.id, e)}>
							info_outline
						</Icon>
					</TableCell>
					<TableCell width="100px" padding='none'>
						<Icon
							className={this.classes.editIcon}
							onClick={(e) =>
								this.getSingleAccountData(item.id, e)}>
							mode_edit
						</Icon>
						<Icon
							className={this.classes.editIcon}
							onClick={(e) =>
								this.handleOpenModalConfirm(item.id, e)}>
							delete
						</Icon>
					</TableCell>
				</TableRow>
			)
		})

		return result.map(item => item)
	}

	renderAccountInfoList = () => {
		let items = this.state.accountInfo
		let result = []

		if (items.name) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Title
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.name}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.first_name) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							First Name
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.first_name}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.last_name) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Last Name
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.last_name}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.email) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Email
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.email}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.address_1) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Address Line 1
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.address_1}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.address_2) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Address Line 2
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.address_2}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.town) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Town
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.town}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.region) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Region
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.region}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.postcode) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Postcode
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.postcode}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.country) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Country
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.country}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.phone) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Phone number
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.phone}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.type) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Type
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.type}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.status) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Status
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.status}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.updated_at) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Last update
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.updated_at}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.school_type) {
			result.push(
				<div>
					<ListItem
						className={this.classes.listItem}
						key={Math.random()}>
						<ListItemText
							className={this.classes.listItemText}>
							<span className={this.classes.listItemTtitle}>
								Scholl Type
							</span>
						</ListItemText>
						<ListItemText className={this.classes.listItemText}>
							{items.school_type}
						</ListItemText>
					</ListItem>
					<h2 className="align-center">Billings</h2>
				</div>
			)
		}

		if (items.billing_title) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Title
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.billing_title}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.billing_first_name) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							First Name
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.billing_first_name}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.billing_last_name) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Last Name
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.billing_last_name}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.billing_email) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Office email for invoice/receipt
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.billing_email}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.billing_name) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Organization Name
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.billing_name}
					</ListItemText>
				</ListItem>
			)
		}

		if (items.maths_circle_id) {
			result.push(
				<ListItem
					className={this.classes.listItem}
					key={Math.random()}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Maths Circle Id
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.maths_circle_id}
					</ListItemText>
				</ListItem>
			)
		}

		return result.map(item => item)
	}

	deleteAccount = id => {
		post(`/admin/accounts/${id}/delete`, {}, token).then(res => {
			this.handleCloseModalConfirm()
			this.getAccounts()
		}).catch(err => {
			this.setState({
				'openSnackbar': true,
				'message': `Account id "${id}" doesn't exist`
			})
		})
	}

	componentWillMount() {
		this.getAccounts()
	}

	classes = this.props.classes;

	render() {
		const { accounts } = this.state

		let preload = accounts ? accounts.isFetching : true
		let last_page = accounts && accounts.meta ? accounts.meta.last_page : 1
		let current_page = accounts && accounts.meta ? accounts.meta.current_page : 1
		let disable = !this.state.name || parseInt(this.state.order) < 0
		return (
			preload ?
				<div className={this.classes.progressWrapper}>
					<CircularProgress className={this.classes.progress} size={50} />
				</div>
				:
				<div>
					<Snackbar
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
						open={this.state.openSnackbar}
						autoHideDuration={6000}
						onClose={this.handleCloseSnackbar}
						SnackbarContentProps={{
							'aria-describedby': 'message-id',
						}}
						message={<span id="message-id">{this.state.message}</span>}
					/>
					<Dialog
						open={this.state.openConfirm}
						onClose={this.handleCloseModalConfirm}>
						<DialogTitle>
							<Icon
								className={this.classes.closeIcon}
								onClick={this.handleCloseModalConfirm}>
								close
							</Icon>
							<br />
							Are you sure you want delete this stage?
						</DialogTitle>
						<DialogActions className={this.classes.justifyCenter}>
							<Button
								variant="raised"
								color="primary"
								onClick={() => this.deleteAccount(this.state.deleteId)}>
								Yes
							</Button>
							<Button
								variant="raised"
								color="primary"
								onClick={this.handleCloseModalConfirm}>
								No
							</Button>
						</DialogActions>
					</Dialog>
					<Dialog
						open={this.state.openInfo}
						onClose={this.handleCloseInfoModal}>
						<Icon
							className={this.classes.closeIcon}
							onClick={this.handleCloseInfoModal}>
							close
						</Icon>
						<DialogTitle>{this.state.accountInfo.name}</DialogTitle>
						<DialogContent>
							<List>
								{this.renderAccountInfoList()}
							</List>
						</DialogContent>
					</Dialog>
					<Dialog
						className="modal-wrap align-center"
						open={this.state.open}
						onClose={this.handleClose}
						aria-labelledby="simple-dialog-title">
						<Icon
							className={this.classes.closeIcon}
							onClick={this.handleCloseModal}>
							close
					</Icon>
						{
							this.state.id ?
								(
									<DialogTitle id="simple-dialog-title">
										Edit account
							</DialogTitle>
								) :
								(
									<DialogTitle id="simple-dialog-title">
										Add account
							</DialogTitle>
								)
						}
						<div className="input-wrap">
							<TextField
								id="name"
								label="Name"
								name="name"
								value={this.state.name}
								onInput={this.handleInputChange}
								margin="normal"
								fullWidth
							/>
						</div>
						<div className="input-wrap">
							<FormControl className={this.classes.formControl}>
								<InputLabel htmlFor="stage-select">
									Type
                            </InputLabel>
								<Select
									value={this.state.type || 'family'}
									onChange={this.handleInputChange}
									inputProps={{
										id: "stage-select",
										name: "type"
									}}
									autoWidth
								>
									<MenuItem value='family'>
										Family account
									</MenuItem>
									<MenuItem value='school'>
										School account
									</MenuItem>
								</Select>
							</FormControl>
						</div>
						<div className="input-wrap">
							<FormControl className={this.classes.formControl}>
								<InputLabel htmlFor="stage-select">
									Status
                            	</InputLabel>
								<Select
									value={this.state.status || 0}
									onChange={this.handleInputChange}
									inputProps={{
										id: "stage-select",
										name: "status"
									}}
									autoWidth
								>
									<MenuItem value={0}>
										Inactive
									</MenuItem>
									<MenuItem value={1}>
										Awaiting confirm
									</MenuItem>
									<MenuItem value={2}>
										Active
									</MenuItem>
								</Select>
							</FormControl>
						</div>
						<div className="input-wrap">
							<TextField
								id="maths_circle_id"
								label="Maths Circle Id"
								name="maths_circle_id"
								value={this.state.maths_circle_id}
								onInput={this.handleInputChange}
								margin="normal"
								type='number'
								fullWidth
							/>
						</div>
						<Button
							variant="raised"
							color="primary"
							className={this.classes.button}
							onClick={this.onSubmit}
							disabled={disable}>
							{this.state.id ? "Edit" : "Add"}
						</Button>
					</Dialog>
					<div className={this.classes.titleWrap}>
						<h2 className={this.props.classes.title}>Accounts</h2>
						<Button
							variant="raised"
							color="primary"
							onClick={this.handleOpenModal}>
							Add account
						</Button>
					</div>
					{
						accounts && accounts.data.length ?
							<Table className={this.classes.table}>
								<TableHead>
									<TableRow>
										<TableCell padding='none'>
											TITLE
									</TableCell>
										<TableCell padding='none'>
											TYPE
									</TableCell>
										<TableCell padding='none'>
											SUBSCRIPTION
									</TableCell>
										<TableCell padding='none'>
											STATUS
									</TableCell>
										<TableCell padding='none'>
											INFO
									</TableCell>
										<TableCell padding='none'>
											ACTIONS
									</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{this.renderAccountsList()}
								</TableBody>
							</Table>
							: null
					}
					{last_page > 1 ?
						(<ReactPaginate previousLabel={<Icon color="primary">navigate_before</Icon>}
							nextLabel={<Icon color="primary">navigate_next</Icon>}
							breakLabel={<a href="">...</a>}
							breakClassName={"break-me"}
							pageCount={last_page}
							initialPage={current_page - 1}
							disableInitialCallback={true}
							marginPagesDisplayed={2}
							pageRangeDisplayed={5}
							onPageChange={this.handlePageChange}
							containerClassName={"pagination"}
							subContainerClassName={"pages pagination"}
							activeClassName={"active"} />)
						: ''
					}
				</div>
		)
	}

}

export default withStyles(styles)(Accounts);



// WEBPACK FOOTER //
// ./src/components/content/Accounts.js